<template>
  <v-dialog
    :value="value"
    max-width="700px"
    persistent
  >
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="auto">
            <h3>Neues Szenario aus Bestehendem erstellen</h3>
          </v-col>
          <v-spacer />
          <v-col cols="auto">
            <v-btn
              icon
              @click="close"
            >
              <v-icon>fa-times</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-alert
          elevation="2"
          border="top"
          colored-border
          :type="confirmed ? 'success' : savingError ? 'error' : 'info'"
          class="mt-3"
        >
          <template v-if="confirmed">
            Das Szenario wurde erfolgreich erstellt und ist nun im Editiermodus
            geöffnet.
          </template>
          <template v-else-if="savingError">
            Das Szenario konnte nicht erstellt werden: <br>
            {{ savingError }}
          </template>
          <template v-else>
            Diese Aktion erstellt ein neues Szenario mit den selben
            Eingangsparametern des aktuell ausgewählten Szenarios. Das neue Szenario
            wird ausgewählt und im Editiermodus geöffnet.
          </template>
        </v-alert>
        <v-text-field
          v-if="!confirmed"
          v-model="newUpdateDescription"
          :rules="[rules.required]"
          counter
          maxlength="50"
          :disabled="confirmed"
          label="Name für neues Szenario *"
        />
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-center">
        <v-btn
          class="my-3"
          color="primary"
          :loading="saving"
          :disabled="!newUpdateDescription || saving || confirmed"
          @click="createNewUpdate"
        >
          Neues Szenario erstellen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

/*
 * Update creation dialog.
 * TODO: error handling überarbeiten (gibt bisher rohe server messages durch)
 */
export default {
  name: "CreateUpdateDialog",
  props: {
    value: Boolean
  },
  data() {
    return {
      confirmed: false,
      saving: false,
      newUpdateDescription: "",
      rules: {
        required: value => !!value || "Pflichtfeld"
      },
      savingError: null
    };
  },
  computed: {
    ...mapGetters(["selectedUpdate", "updatesFilteredByAgs", "user"])
  },
  methods: {
    ...mapActions(["addUpdate"]),
    async createNewUpdate() {
      this.saving = true;
      await $api
        .post(`update/fromExisting?client_id=${this.user.clientId}`, {
          oldUpdateId: this.selectedUpdate.updateId,
          newUpdateDescription: this.newUpdateDescription
        })
        .then(res => {
          var newUpdate = res.data.update;
          window.EventBus.$emit("reloadUpdates");
          //TODO: replace addUpdate with wait for reloadUpdates?
          this.addUpdate({
            agsId: newUpdate.agsId,
            dateOfUpdate: newUpdate.dateOfUpdate,
            description: newUpdate.description,
            updateId: newUpdate.updateId,
            updateStatus: newUpdate.updateStatus
          });
          this.$emit("updateCreated", newUpdate.updateId);
          this.confirmed = true;
        })
        .catch(error => {
          this.savingError = error.response.data.message;
        });
      this.saving = false;
    },
    close() {
      this.$emit("input", false);
    }
  },
  watch: {
    value(newVal) {
      this.savingError = null;
      if (newVal) {
        // reset component state
        Object.assign(this.$data, this.$options.data());
      }
    }
  }
};
</script>
